import axios from "axios";
import firebase from "./firebase";
import request from "../infra/request";

export const getClinicCommunicationMethodService = async () => {
  let result = {};
  try {
    const response = await request.get("/admin/clinic-settings/communication-methods");
    result = response.data.methods;
  } catch (error) {
    console.log(error);
  }
  return result;
};

export const setClinicCommunicationMethodService = async (methods) => {
  try {
    await request.put("/admin/clinic-settings/communication-methods", { methods });
  } catch (error) {
    console.log(error);
  }
};

export const getClinicPreferenceService = async () => {
  let result = {};
  try {
    const response = await request.get("/admin/clinic-settings/preferences");
    return response.data.preferences;
  } catch (error) {
    console.log(error);
    return result;
  }
};

export const setClinicPreferenceService = async (clinicPreference) => {
  try {
    await request.put("/admin/clinic-settings/preferences", { preferences: clinicPreference });
  } catch (error) {
    console.log(error);
  }
};

export const updateClinicService = async ({ caId, clinic }) => {
  const userIdToken = await firebase.currentUser().getIdToken();
  return axios.patch(
    `${process.env.REACT_APP_UPDATE_CLINIC}/${clinic.id}`,
    { caId, clinic },
    { headers: { Authorization: `Bearer ${userIdToken}` } }
  );
};
